import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import { useCallback } from "react";
import { Header } from "../../../components/Header";
import InfoGenesis from "../../../assets/img/Featured/tablet-info-genesis.png";
import Loyalty from "../../../assets/img/Featured/app-rewards.png";

const CafePage = () => {
    const IGKiosk = "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/touchpoint-all-assets/featured-solution-nav/kiosk-food-order.png";
    const DigitalMenu = "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/touchpoint-all-assets/featured-solution-nav/digital-menu.png";
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page cafePage">
            <Header />
            <div className="page-header">Business & Industry Dining</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Cafe</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    In fast-paced corporate dining, speed and accuracy 
                    drive satisfaction. InfoGenesis POS, IG Digital Menu 
                    Board, and IG Kiosk support preference-driven service 
                    with self-ordering and streamlined payment options.{'\n\n'}
                    
                    By reducing wait times and minimizing order errors, 
                    these solutions help operators maintain steady 
                    throughput while delivering timely, consistent 
                    experiences that meet the evolving expectations of 
                    today's workplace diners.
                </div>

            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Business & Industry Dining - Cafe", "InfoGenesis");
                    addFlow("InfoGenesis");
                    navigate("/solutions/info-genesis")}}>
                    <div className="item-head">
                        <LogoMini />
                        InfoGenesis
                    </div>
                    <img src={InfoGenesis} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Business & Industry Dining - Cafe", "IG Kiosk");
                    addFlow("IG Kiosk");
                    navigate("/solutions/ig-kiosk")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Kiosk
                    </div>
                    <img src={IGKiosk} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Business & Industry Dining - Cafe", "IG Digital Menu Board");
                    addFlow("IG Digital Menu Board");
                    navigate("/solutions/digital-menu")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Digital Menu Board
                    </div>
                    <img src={DigitalMenu} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Business & Industry Dining - Cafe", "Loyalty & Promotions");
                    addFlow("Loyalty & Promotions");
                    navigate("/solutions/loyalty")}}>
                    <div className="item-head">
                        <LogoMini />
                        Loyalty & Promotions
                    </div>
                    <img src={Loyalty} alt="" />
                </div>
            </FeaturedSolutions>
        </div>
    )
}
export default CafePage;